export * from './lib/services/title.service';

export * from './lib/types/title-update-event.type';

export * from './lib/title.module';
